import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { DjangoApiService } from '../../../shared/services/django-api.service';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {CardsBasicComponent} from "../../../shared/components/cards/cards-basic/cards-basic.component";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {LanguageService} from "../../../shared/services/language.service";

export interface CustomUser {
  email: string;
  first_name: string;
  last_name: string;
  groups: string[];
  product_subscriptions: string[];
}

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  standalone: true,
  styleUrls: ['./user-list.component.css'],
  imports: [
    MatPaginator,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    CardsBasicComponent,
  ]
})
export class UserListComponent implements OnInit, AfterViewInit {
  // Definierte Spalten (die Detailzeile wird über eine eigene Spalte angesteuert)
  columnsToDisplay: string[] = ['first_name', 'last_name', 'email', 'groups'];
  columnsHeaders: string[] = ['First Name', 'Last Name', 'E-Mail', 'Groups'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  dataSource = new MatTableDataSource<CustomUser>();
  expandedElement: CustomUser | null = null;
  totalUsers: number = 0;
  pageSize: number = 10;
  currentPage: number = 0;
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;

  private subscriptions: Subscription = new Subscription();

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private _apiService: DjangoApiService,
              private _languageService: LanguageService,
              private _translate: TranslateService) {}

  ngOnInit(): void {
    this.setupLanguageSubscription();
    this.fetchUsers(this.currentPage, this.pageSize);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  // Holt die Nutzerdaten von der API (erwartet eine paginierte Antwort: { count, results, ... })
  fetchUsers(pageIndex: number, pageSize: number): void {
    this.subscriptions.add(
      this._apiService.fetchUserList().subscribe({
        next: (response: any) => {
          // Erwartete API-Antwort: { count, results, next, previous }
          this.dataSource.data = response.results;
          this.totalUsers = response.count;
          console.log(response);
        },
        error: (error: any) => {
          console.error('Error fetching user information', error);
        },
      })
    );
  }

  /** Checks whether an element is expanded. */
  isExpanded(element: any) {
    return this.expandedElement === element;
  }

  /** Toggles the expanded state of an element. */
  toggle(element: any) {
    this.expandedElement = this.isExpanded(element) ? null : element;
  }

  // Wird vom Paginator aufgerufen
  onPageChange(event: PageEvent): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchUsers(this.currentPage, this.pageSize);
  }
}
